import React, { useEffect, useRef, useState } from "react";
import { getBaseUrl } from "../../../../../../Redux/Config/AppConfig";
import { useDispatch, useSelector } from "react-redux";
import {
  POST_DEPARTMENT_INVENTORY_REQUEST,
  PUT_DEPARTMENT_INVENTORY_REQUEST,
} from "../../../../../../Utils/Constant";

const AddDepartmentsInventory = ({
  selectedDepartment,
  setSelectedCategory,
  subCategoryId,
  department_id,
}) => {
  const BaseUrl = getBaseUrl();
  const closeBtnRef = useRef(null);
  const dispatch = useDispatch();
  //    const { addCategory } = useSelector((state) => state.restaurant);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    quantity: "",
    unit: "",
    cost_per_unit: "",
    department_id: subCategoryId,
    department_id,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedDepartment) {
      setFormData({
        name: selectedDepartment.name || "",
        description: selectedDepartment.description || "",
        quantity: selectedDepartment.quantity || "",
        unit: selectedDepartment.unit || "",
        cost_per_unit: selectedDepartment.cost_per_unit || "",
        category_id: subCategoryId,
        department_id,
      });
    } else {
      setFormData({
        name: "",
        description: "",
        quantity: "",
        unit: "",
        cost_per_unit: "",
      });
    }
    setErrors({});
  }, [selectedDepartment]);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Category name is required.";
    if (!formData.cost_per_unit || isNaN(Number(formData.cost_per_unit))) newErrors.cost_per_unit = "Price per unit is required and must be a number.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    if (selectedDepartment) {
      dispatch({
        type: PUT_DEPARTMENT_INVENTORY_REQUEST,
        payload: {
          id: selectedDepartment?.id,
          body: { ...formData, category_id: subCategoryId, department_id },
        },
      });
    } else {
      dispatch({
        type: POST_DEPARTMENT_INVENTORY_REQUEST,
        payload: {
          body: { ...formData, category_id: subCategoryId, department_id },
        },
      });
    }
    setFormData({
      name: "",
      description: "",
      quantity: "",
      unit: "",
      cost_per_unit: "",
    });
    setErrors({});
    closeBtnRef.current?.click();
  };

  const handleClear = () => {
    setFormData({
      name: "",
      description: "",
      quantity: "",
      unit: "",
      cost_per_unit: "",
    });
    setErrors({});
  };

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="add-department-inventory"
      aria-labelledby="add-department-inventory"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">
          {selectedDepartment ? "Edit Item" : "Add Item"}
        </h5>
        <button
          ref={closeBtnRef}
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => setErrors({})}
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Item Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="name"
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter item name"
          />
          {errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>

        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Description
            {/* <span className="text-danger">*</span> */}
          </label>
          <textarea
            name="description"
            className={`form-control ${errors.description ? "is-invalid" : ""}`}
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter item description"
          ></textarea>
          {errors.description && (
            <div className="invalid-feedback">{errors.description}</div>
          )}
        </div>

        {/* <div className="form-group mb-3">
          <label className="form-label text-muted">
            Price <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            step="1"
            name="price"
            className={`form-control ${errors.price ? "is-invalid" : ""}`}
            value={formData.price}
            onChange={handleChange}
            placeholder="Enter price"
          />
          {errors.price && (
            <div className="invalid-feedback">{errors.price}</div>
          )}
        </div> */}

        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Quantity <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            name="quantity"
            className={`form-control ${errors.quantity ? "is-invalid" : ""}`}
            value={formData.quantity}
            onChange={handleChange}
            placeholder="Enter available quantity"
          />
          {errors.quantity && (
            <div className="invalid-feedback">{errors.quantity}</div>
          )}
        </div>

        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Price - Per Unit <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            name="cost_per_unit"
            className={`form-control ${errors.cost_per_unit ? "is-invalid" : ""}`}
            value={formData.cost_per_unit}
            onChange={handleChange}
            placeholder="Enter price per unit"
          />
          {errors.cost_per_unit && <div className="invalid-feedback">{errors.cost_per_unit}</div>}
        </div>

        {/* <div className="form-group mb-3">
          <label className="form-label text-muted">
            Unit <span className="text-danger">*</span>
          </label>
          <select
            name="unit"
            className={`form-control ${errors.unit ? "is-invalid" : ""}`}
            value={formData.unit}
            onChange={handleChange}
          >
            <option value="">Select unit</option>
            <option value="kg">Kilogram</option>
            <option value="ltr">Liter</option>
            <option value="mg">Milligram</option>
            <option value="tn">Tonne</option>
            <option value="grm">Gram</option>
            <option value="pcs">Per Pieces</option>
            <option value="cup">Per Cup</option>
            <option value="pnd">Pound</option>
          </select>
          {errors.unit && (
            <div className="invalid-feedback">{errors.unit}</div>
          )}
        </div> */}
        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Unit <span className="text-danger">*</span>
          </label>
          <select
            name="unit"
            className={`form-control ${errors.unit ? "is-invalid" : ""}`}
            value={formData.unit}
            onChange={handleChange}
          >
            <option value="">Select unit</option>

            {/* Weight */}
            <option value="Milligram (mg)">Milligram (mg)</option>
            <option value="Gram (g)">Gram (g)</option>
            <option value="Kilogram (kg)">Kilogram (kg)</option>
            <option value="Tonne (ton)">Tonne (ton)</option>
            <option value="Pound (lb)">Pound (lb)</option>
            <option value="Ounce (oz)">Ounce (oz)</option>

            {/* Volume */}
            <option value="Milliliter (ml)">Milliliter (ml)</option>
            <option value="Liter (l)">Liter (l)</option>
            <option value="Cup">Cup</option>
            <option value="Pint (pt)">Pint (pt)</option>
            <option value="Quart (qt)">Quart (qt)</option>
            <option value="Gallon (gal)">Gallon (gal)</option>

            {/* Length */}
            <option value="Millimeter (mm)">Millimeter (mm)</option>
            <option value="Centimeter (cm)">Centimeter (cm)</option>
            <option value="Meter (m)">Meter (m)</option>
            <option value="Inch">Inch</option>
            <option value="Foot (ft)">Foot (ft)</option>
            <option value="Yard (yd)">Yard (yd)</option>

            {/* Count / Items */}
            <option value="Pieces (pcs)">Pieces (pcs)</option>
            <option value="Box">Box</option>
            <option value="Packet">Packet</option>
            <option value="Set">Set</option>
            <option value="Roll">Roll</option>
            <option value="Dozen">Dozen</option>
            <option value="Bundle">Bundle</option>
            <option value="Unit">Unit</option>

            {/* Containers */}
            <option value="Bottle">Bottle</option>
            <option value="Jar">Jar</option>
            <option value="Can">Can</option>
            <option value="Bag">Bag</option>
            <option value="Drum">Drum</option>
            <option value="Barrel">Barrel</option>

            {/* Misc */}
            <option value="Sheet">Sheet</option>
            <option value="Tablet">Tablet</option>
            <option value="Tube">Tube</option>
            <option value="Strip">Strip</option>
            <option value="Sachet">Sachet</option>
          </select>
          {errors.unit && <div className="invalid-feedback">{errors.unit}</div>}
        </div>

        <div className="d-flex">
          <button
            type="button"
            className="btn w-100 me-1 py-2 btn-primary"
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            type="button"
            className="btn w-100 ms-1 py-2 btn-dark"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDepartmentsInventory;
